import React from "react";

import { Pagination as PaginationType, PaginationParams } from "store/common/types";
import BackToTop from "components/common/TableUI/BackToTop";
import Pagination, { PaginationWrapper } from "components/common/TableUI/Pagination";
import RowsPerPage from "components/common/TableUI/RowsPerPage";

type ResourceTablePagination = {
  params: PaginationParams;
  paginationValues: PaginationType;
  onUpdateParams: (param: Partial<PaginationParams>) => void;
};

const ResourceTablePagination = ({ params, paginationValues, onUpdateParams }: ResourceTablePagination) => {
  return (
    <PaginationWrapper>
      <RowsPerPage pageSize={params.size} onClick={(size) => onUpdateParams({ size })} />
      <Pagination
        currentPage={params.page}
        totalPages={paginationValues.totalPages}
        onClick={(page) => onUpdateParams({ page })}
      />
      <BackToTop />
    </PaginationWrapper>
  );
};

export default ResourceTablePagination;
